/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_edit4 = /** @type {(inputs: {}) => string} */ () => {
	return `Edit`
};

const fr_edit4 = /** @type {(inputs: {}) => string} */ () => {
	return `Modifier`
};

const de_edit4 = /** @type {(inputs: {}) => string} */ () => {
	return `Bearbeiten`
};

const es_edit4 = /** @type {(inputs: {}) => string} */ () => {
	return `Editar`
};

const it_edit4 = /** @type {(inputs: {}) => string} */ () => {
	return `Modificare`
};

const ar_edit4 = /** @type {(inputs: {}) => string} */ () => {
	return `يحرر`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "fr" | "de" | "es" | "it" | "ar" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const edit4 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.edit4(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("edit4", locale)
	if (locale === "en") return en_edit4(inputs)
	if (locale === "fr") return fr_edit4(inputs)
	if (locale === "de") return de_edit4(inputs)
	if (locale === "es") return es_edit4(inputs)
	if (locale === "it") return it_edit4(inputs)
	return ar_edit4(inputs)
};
export { edit4 as "EDIT" }